import { Navigate, Routes, Route } from "react-router-dom";
import Page404 from "./components/Page404";

import ProtectedRoute from "./components/ProtectedRoute";
import LoginNewPage from "./LoginNewPage";
import DrnSuperAdmin from "./clothingAdminPages/DrnSuperAdmin";
import DNRBillTable from "./clothingAdminPages/DNRBillTable";

const CustomeRoutes = () => {

  return (
    <Routes>
      {/* home */}
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/404" element={<Page404 />} />

      <Route path="/login" element={<LoginNewPage />} />

      <Route element={<ProtectedRoute loggedinUserRole="dnr_super_admin" />}>
        <Route path="/dnr_super_admin" element={<DrnSuperAdmin />} />
        <Route path="/dnr_billings" element={<DNRBillTable />} />
      </Route>

      <Route path="*" element={<Page404 />} />
    </Routes>
  );
};

export default CustomeRoutes;
